const REPORT_TYPE_INSTANT_KEY = 'instant'
const REPORT_TYPE_DELAYED_KEY = 'delayed'
const REPORT_TYPE_SCHEDULED_KEY = 'scheduled'
export default {
  methods: {
    // instant report methods
    getInstantReportIcon (event) {
      return `/img/icons/${!this.isInstantReportDisabled(event) ? 'report-play-icon.svg' : 'report-play-disabled-icon.svg'}`
    },
    isInstantReportDisabled (event) {
      return !this.hasType(event?.rowData?.types, REPORT_TYPE_INSTANT_KEY)
    },

    // delayed report methods
    getDelayedReportIcon (event) {
      return `/img/icons/${!this.isDelayedReportDisabled(event) ? 'report-email-green-icon.svg' : 'report-email-icon.svg'}`
    },
    isDelayedReportDisabled (event) {
      return !this.hasType(event?.rowData?.types, REPORT_TYPE_DELAYED_KEY)
    },

    // automatic report methods
    getAutomaticReportIcon (event) {
      return `/img/icons/${!this.isAutomaticReportDisabled(event) ? 'report-calendar-green-icon.svg' : 'report-calendar-disabled-icon.svg'}`
    },
    isAutomaticReportDisabled (event) {
      return !this.hasType(event?.rowData?.types, REPORT_TYPE_SCHEDULED_KEY)
    },

    openReportOptionsDialog (event, reportType) {
      const { name: categoryName } = event?.rowData?.category || event?.data?.category || {}
      // skip if category name or report type is invalid
      if (!categoryName || !reportType) {
        return
      }

      const titleMapping = {
        [REPORT_TYPE_INSTANT_KEY]: this.$t('base/reports.instant_report_creation_title'),
        [REPORT_TYPE_DELAYED_KEY]: this.$t('base/reports.delayed_report_creation_title'),
        [REPORT_TYPE_SCHEDULED_KEY]: this.$t('base/reports.scheduled_report_creation_title')
      }

      this.setReportBaseData(event.rowData || event?.data)
      this.setReportType(reportType)
      this.setReportCategory(categoryName)
      this.setReportTitle(titleMapping[reportType])
      this.$set(this.reportOptionsDialogConfig, 'show', true)
    },

    hasType (types, typeKey) {
      if (!types) {
        return false
      }
      return types?.some(type => type === typeKey)
    }
  }
}
